import { __awaiter } from "tslib";
import { getLocale } from '../locale';
const importLocale = (locale) => import(
/* Exclude locale file internals */
/* webpackMode: "lazy", webpackChunkName: "utils/date-fns-locale-[index]", webpackExclude: /_lib/ */
`date-fns/locale/${locale}/index.js`).catch(() => null);
let localeFile;
export const initLocaleFile = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const localeParts = getLocale().split('_');
    const localeVariations = [
        `${localeParts[0]}-${(_a = localeParts[1]) === null || _a === void 0 ? void 0 : _a.toUpperCase()}`,
        localeParts[0],
        'en-GB',
    ];
    // bug in eslint, have to use eslint-disable there
    // eslint-disable-next-line no-unused-vars
    for (const localeVariation of localeVariations) {
        // eslint-disable-next-line no-await-in-loop
        const possibleLocaleFile = yield importLocale(localeVariation);
        // @ts-ignore
        if (possibleLocaleFile === null || possibleLocaleFile === void 0 ? void 0 : possibleLocaleFile.localize) {
            localeFile = possibleLocaleFile;
            return;
        }
    }
});
const getLocaleFile = () => localeFile;
export default getLocaleFile;
// Used only in tests
export const clearLocaleFile = () => {
    localeFile = undefined;
};
//# sourceMappingURL=getLocaleFile.js.map